<!-- 百分比上传组件 -->

<template>
	<div class="">
		<el-date-picker size="small" v-model="time1.year" @focus="beforeTimeClick('y')" @change="timeFormate('y')" align="right" type="year" format="yyyy 年" value-format="yyyy-MM-dd" placeholder="选择年">
		</el-date-picker>
		<el-date-picker size="small" v-model="time1.month"  @focus="beforeTimeClick('m')" @change="timeFormate('m')" align="right" type="month" format="MM 月" value-format="yyyy-MM-dd" placeholder="选择月">
		</el-date-picker>
		<el-date-picker size="small" v-model="time1.day"  @focus="beforeTimeClick('d')" @change="timeFormate('d')" align="right" format="dd 日" value-format="yyyy-MM-dd" placeholder="选择日">
		</el-date-picker>
	</div>
</template>

<script>
    import { getToken } from '@/utils/auth';
    import { getFileToken } from '@/api/account';
    export default{
       props:['outTime'],
    	 data(){
    	 	 return{
						 time1: {
							 year: '',
							 month: '',
							 day: '',
						 },
						 strTime:''
    	 	 }
    	 },
       watch:{
					 time1: {
						 handler: function(val) {
							 	this.strTime = this.timePostSet(val);
								this.$emit('time-frash',this.strTime);
								//返回给外部
						 },
						 deep: true
					 },
					 outTime:function(val){
						  this.timeShowSet(val);
					 }
       },
    	 methods:{
					 beforeTimeClick:function(type){

						 		if(type === "m"){
						 			 this.time1.month = this.time1.year + '-01-01';
						 		}else if(type === "d"){
						 			 this.time1.day = this.time1.month + '-01';
						 		}

					 },
					 timeFormate: function(type) {
				         if (type == "y") {
				           this.time1.month = '';
				           this.time1.day = '';
				         } else if (type == "m") {
				           this.time1.year = this.time1.month;
				           this.time1.day = '';
				         } else {
				           this.time1.year = this.time1.day;
				           this.time1.month = this.time1.day;
				         }

			     },
					 timePostSet: function(val) {
						   console.log(val);
				       var storage = '';
				       if (val.year) {
				         storage = val.year.split("-")[0];
				       };

				       if (val.month) {
				         storage = storage + '-' + val.month.split("-")[1];
				       }

				       if (val.day) {
				         storage = storage + '-' + val.day.split("-")[2];
				       }

				       return storage;
			     },

			     timeShowSet: function(val, time) {

				       // val = val.replace(/年/g, ",");
				       // val = val.replace(/月/g, ",");
				       // val = val.replace(/日/g, "");

				       var tempArr = val.split("-");
				       var timeArr = [];
				       for(var i=0;i<tempArr.length;i++){
				           if(tempArr[i]&&tempArr[i]!=''){
				               timeArr.push(tempArr[i]);
				           }
				       }

			         if (timeArr.length == 1) {
			           this.time1.year = val.substring(0,val.length);
			         } else if (timeArr.length == 2) {
			           this.time1.year = val.substring(0,4);
			           this.time1.month = val+'01';
			         } else if (timeArr.length == 3) {
			           this.time1.year = val;
			           this.time1.month = val;
			           this.time1.day = val;
			         }


			     },
    	},

      created:function(){
					this.timeShowSet(this.outTime);
      }
    }

</script>

<style>

</style>



// WEBPACK FOOTER //
// date.vue?4d1b7431